import { Skeleton } from "@mantine/core";
import React from "react";

const SchemeLoading = () => {
  return (
    <div className='container mx-auto'>
      <Skeleton height={200} className='mt-2' />
      <Skeleton height={50} className='mt-2' />
      <Skeleton height={100} className='mt-2' />
      <div className='grid grid-cols-3 gap-2'>
        <Skeleton height={200} className='mt-2' />
        <Skeleton height={200} className='mt-2' />
        <Skeleton height={200} className='mt-2' />
      </div>
    </div>
  );
};

export default SchemeLoading;
